import { loggerFor } from '../helpers/debug.js';
export const log = loggerFor('TRx');
